import smoothscroll from 'smoothscroll-polyfill';
import { useEffect } from 'react';

const useSiteInit = () => {
  useEffect(() => {
    smoothscroll.polyfill();

    // 加入 viewHeight 供 css 使用
    const onResize = () => {
      document.documentElement.style.setProperty(
        '--viewHeight',
        `${window.innerHeight}px`,
      );
    };

    document.documentElement.style.setProperty(
      '--fixedViewHeight',
      `${window.innerHeight}px`,
    );
    document.documentElement.style.setProperty(
      '--viewHeight',
      `${window.innerHeight}px`,
    );

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);
};

export default useSiteInit;
